import { useMessage } from 'framework/hooks/web/useMessage'
import { useIntervalFn } from '@vueuse/core'
import { useSystemMenuStore } from '@admin/store/modules/systemMenu'

export async function checkUpdate({ pause, isActive, route }) {
  // console.log('检查更新', location)
  const { createConfirm } = useMessage()
  const systemMenuStore = useSystemMenuStore()

  // 通过 route.path 查找 systemMenuStore.allSystemList 的顶级节点
  const findTopLevelMenuByPath = (path, menuList) => {
    for (const item of menuList) {
      // 如果当前节点有 children，递归查找
      if (item.children && item.children.length > 0) {
        const found = findTopLevelMenuByPath(path, item.children)
        if (found) {
          // 如果在子节点中找到了，返回顶级节点
          return item
        }
      }
      // 判断当前节点的 path 是否和传入的 path 匹配
      if (item.path === path) {
        return item
      }
    }
    return null
  }
  try {
    // 检测前端资源是否有更新
    const response = await fetch(`${location.origin}/version/versionData.json`, {
      headers: {
        'Cache-Control': 'no-cache',
      },
    }).then((res) => res.json())

    // 获取顶级菜单
    const topLevelMenu = findTopLevelMenuByPath(route?.path, systemMenuStore?.allSystemList)
    const version = response.version

    let updateVersionList: any = []
    const versionList = version?.split('-') || []
    if (versionList?.length > 1) {
      updateVersionList = versionList[1]?.split(',').filter((item) => Boolean(item)) || []
    }
    if (!localStorage.getItem('v3_version')) {
      localStorage.setItem('v3_version', response.version)
    } else {
      if (
        localStorage.getItem('v3_version') !== response.version &&
        (updateVersionList.includes(topLevelMenu?.title) || updateVersionList.includes('all'))
      ) {
        console.log('弹窗更新版本')
        // 增加一个全局变量用于标记弹窗状态，防止重复弹窗
        if ((window as any).__version_update_modal_open__) {
          return
        }
        ;(window as any).__version_update_modal_open__ = true
        createConfirm({
          title: `系统检测到有新版本发布`,
          content: '是否立即更新？',
          iconType: 'warning',
          onOk: () => {
            localStorage.setItem('v3_version', response.version)
            window.location.reload()
          },
          onCancel: () => {
            if (isActive) {
              pause()
            } // 暂停定时器
            ;(window as any).__version_update_modal_open__ = false
          },
        })
      }
    }
  } catch (e) {
    return Promise.reject(e)
  }
}
/**
 * @description 初始化版本检测器
 */
export function useCheckVersion(route) {
  const { pause, resume, isActive } = useIntervalFn(
    () => {
      checkUpdate({ pause, isActive, route })
    },
    600000,
    { immediate: true },
  )
  return {
    pause,
    resume,
    isActive,
  }
}
